import { dGet } from '@core/utils'
import { isSiDaProperty } from '@merchant-backend/util'
import { getMerchantInfo, isSiDaMember } from '@util'
import { SIYI_MEMBER_WAP_HOME, SIYI_TEAM_WAP_HOME } from './constant'

export const groupNotVerified = () => {
  const { group } = getMerchantInfo()
  return isSiDaMember() && dGet(group, 'examine') != 1
}

export const goToSiYiMemberHome = (merchant_id, theme) => {
  // 三大暂时不做跳转
  if (isSiDaProperty()) return

  let url = `${SIYI_MEMBER_WAP_HOME}?merchant_id=${merchant_id}`

  // if (theme !== null && theme !== undefined) {
  //   url = `${url}&theme=${theme}`
  // }

  window.open(url)
}

export const goToSiYiTeamHome = (merchant_id, theme) => {
  // 三大暂时不做跳转
  if (isSiDaProperty()) return

  let url = `${SIYI_TEAM_WAP_HOME}?merchant_id=${merchant_id}`

  // if (theme !== null && theme !== undefined) {
  //   url = `${url}&theme=${theme}`
  // }

  window.open(url)
}
